// extracted by mini-css-extract-plugin
export default {"wrapper":"thanks_wrapper__cspBl","main":"thanks_main__Xias4","sendButton":"thanks_sendButton__YHcXZ","footer":"thanks_footer__0EkWx"};